module.exports = __webpack_public_path__ + "static/media/back-b.f9f55dd1.svg";